import { render, staticRenderFns } from "./BillingPlans.vue?vue&type=template&id=9985ec46&scoped=true"
import script from "./BillingPlans.vue?vue&type=script&lang=js"
export * from "./BillingPlans.vue?vue&type=script&lang=js"
import style0 from "./BillingPlans.vue?vue&type=style&index=0&id=9985ec46&prod&scoped=true&lang=scss"
import style1 from "./BillingPlans.vue?vue&type=style&index=1&id=9985ec46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9985ec46",
  null
  
)

export default component.exports